const DEFAULT_HEADER_TITLE = 'Новая заявка';

export function getHeaderTitle(nameValue: unknown, ctxName: unknown): string {
  const v = nameValue ?? ctxName;
  const s = typeof v === 'string' ? v : String(v ?? '');
  const t = s.trim();
  return t || DEFAULT_HEADER_TITLE;
}
